import axios from 'axios';

const integrationApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

integrationApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const integrationService = {
  // GET http://localhost:5000/api/v1/integrations/token
  getToken: () => integrationApi.get('/integrations/token'),

  // POST http://localhost:5000/api/v1/integrations/webhook-override
  overrideWebhook: (data) => integrationApi.post('/integrations/webhook-override', data),
};

export default integrationService;
